import CajaDonas from './CajaDonas.jpg';
import Cedis from './Cedis.jpg';
import Donas from './Donas.jpg';
import Panera from './Panera.jpg';
import PaneraBacia from './PaneraBacia.jpg';
import Precio from './Precio.jpg';
import ChicaOxxoDudas from "./chicaoxxo.png";
import paso1Quesera from "./paso1Quesera.png";
import paso2Quesera from "./paso2Quesera.png";
import paso3Quesera from "./paso3Quesera.png";
import paso4Quesera from "./paso4Quesera.png";
import paso5Quesera from "./paso5Quesera.png";
import paso6Quesera from "./paso6Quesera.png";
import paso7Quesera from "./paso7Quesera.png";
import paso8Quesera from "./paso8Quesera.png";
import paso9Quesera from "./paso9Quesera.png";

import Limpieza01 from "./Limpieza01.jpg";
import reloj01 from "./reloj01.jpg";
import Temperatura01 from "./Temperatura01.jpg";
import Warmer01 from "./Warmer01.png";

// topic 2
import reloj1 from "./reloj1.png";

// topic 3
import circuloColores from "./circuloColores.svg";
import Certificado_Artboard from "./Certificado_Artboard.png";
import Certificado_Artboard02 from "./Certificado_Artboard02.png";

export const imagesTheme3 = {
	topic1: {
		CajaDonas,
		Cedis,
		Donas,
		Panera,
		PaneraBacia,
		Precio,
		ChicaOxxoDudas,
		paso1Quesera,
		paso2Quesera,
		paso3Quesera,
		paso4Quesera,
		paso5Quesera,
		paso6Quesera,
		paso7Quesera,
		paso8Quesera,
		paso9Quesera,
		Limpieza01,
		reloj01,
		Temperatura01,
		Warmer01,
	},
	topic2: {
		reloj1
	},
	topic3: {
		circuloColores,
		Certificado_Artboard,
		Certificado_Artboard02
	}
}